import type { ButtonProps } from '@joyful/ui/core'
import { Button } from '@joyful/ui/core'
import { useSafeRouterOrgSlug } from '@/features/auth/hooks/useRouterOrgSlug'
import type { LinkProps } from 'react-router-dom'
import { Link } from 'react-router-dom'

interface BuildLandingPagePathParams {
  orgSlug: string | null
}

export function buildUnscopedDashboardPath() {
  return `/dashboard`
}

function buildUnscopedLandingPagePath() {
  return buildUnscopedDashboardPath()
}

export function buildLandingPagePath({ orgSlug }: BuildLandingPagePathParams) {
  const unscopedPath = buildUnscopedLandingPagePath()
  return orgSlug === null ? unscopedPath : `/${orgSlug}${unscopedPath}`
}

export function useLandingPagePath() {
  const orgSlug = useSafeRouterOrgSlug()

  return buildLandingPagePath({
    orgSlug,
  })
}

export function LandingPageLink({ children, ...props }: Omit<LinkProps, 'to'>) {
  const path = useLandingPagePath()

  return (
    <Link to={path} {...props}>
      {children ?? `Go to Dashboard`}
    </Link>
  )
}

export function LandingPageButton({ children, ...props }: ButtonProps) {
  const path = useLandingPagePath()

  return (
    <Link to={path}>
      <Button {...props}>{children ?? `Go to Dashboard`}</Button>
    </Link>
  )
}
